import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import ProductCard from "../../Enums/ProductCard";
import ProductsService from "../../services/ProductsService";
import Loader from "../../common/Loader";
import NoData from "../../common/NoData";
import CategoriesService from "../../services/CategoriesService";
import { motion } from "framer-motion";
import "./style.css";

const OurProducts = () => {
	const [data, setData] = useState([]);
	const [categoriesOptions, setCategoriesOptions] = useState([]);
	const [hasCategoriesOptions, setHasCategoriesOptions] = useState(null);
	const [hasProducts, setHasProducts] = useState(null);
	const [loading, setLoading] = useState(true);
	const { t } = useTranslation();
	const navigate = useNavigate();
	const lang = useSelector((state) => state?.lang?.lang);
	const categoriesService = new CategoriesService();
	const productsService = new ProductsService();

	useEffect(() => {
		setLoading(true);
		Promise.all([
			categoriesService.getList({ offset: 0, limit: 4 }),
			productsService.getList({ offset: 0, limit: 4, bestSeller: true }),
		])
			.then((res) => {
				if (res[0]?.status) {
					let response = res[0]?.data?.data?.data?.map((info) => {
						return {
							...info,
							label: lang === "en" ? info?.name_en : info?.name_ar,
							value: info?.id,
						};
					});
					!!response.length
						? setHasCategoriesOptions(1)
						: setHasCategoriesOptions(0);
					setCategoriesOptions(response);
				}
				if (res[1]?.status) {
					let response = res[1]?.data?.data?.data?.map((info) => {
						return {
							...info,
							label: lang === "en" ? info?.name_en : info?.name_ar,
							value: info?.id,
						};
					});
					!!response.length ? setHasProducts(1) : setHasProducts(0);
					setData(response);
				}
				setLoading(false);
			})
			.catch(() => setLoading(false));
	}, []);

	return (
		<div className="products-page">
			{loading && (
				<div style={{ minHeight: "90vh", display: "flex" }}>
					<Loader />
				</div>
			)}
			<div>
				{hasCategoriesOptions === 1 && !!categoriesOptions?.length && (
					<div className="container">
						<div className="categories">
							<div className="d-flex justify-content-between">
								<motion.p
									initial={{ opacity: 0 }}
									animate={{ opacity: 1 }}
									transition={{ delay: 0.25, duration: 1 }}
									className="title">
									{t("categories")}
								</motion.p>
								<Link to="/categories">{t("View All")}</Link>
							</div>
							<div className="row">
								{categoriesOptions?.map((item, index) => {
									return (
										<div
											data-aos="flip-left"
											data-aos-easing="ease-out-cubic"
											data-aos-duration="800"
											key={index}
											onClick={() =>
												navigate(`/category/${item?.id}`, { state: item })
											}
											className="col-md-3 col-6 mb-3">
											<div className="category-card">
												<div className="category-card-image">
													<motion.img
														src={item?.image}
														alt="category"
														whileHover={{ scale: 1.15 }}
														transition={{ type: "spring", stiffness: 200 }}
														className="w-100"
													/>
												</div>
												<p className="title">
													{lang === "en" ? item?.name_en : item?.name_ar}
												</p>
											</div>
										</div>
									);
								})}
							</div>
						</div>
					</div>
				)}
				{hasProducts === 1 && !!data?.length && !loading && (
					<div className="products">
						<div className="container">
							<div className="d-flex justify-content-between">
								<p className="title">{t("Best seller")}</p>{" "}
							</div>
							<div className="row">
								{data?.map((product, index) => {
									return (
										<div className=" col-lg-3 col-md-4 col-6 mb-3" key={index}>
											<ProductCard product={product} hasAddToCart={true} />
										</div>
									);
								})}
							</div>
						</div>
					</div>
				)}
				{!data?.length && !loading && <NoData text={t(`There's no Product`)} />}
			</div>
		</div>
	);
};

export default OurProducts;
